import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getStorageItem } from "../Common/Utility";

/**
 * Renders children only if the current user is admin.
 * Otherwise redirects to redirectTo (default /welcome).
 */
export default function AdminRoute({ children, redirectTo = "/welcome" }) {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    (async () => {
      const admin = await getStorageItem("login", "isAdmin");
      setIsAdmin(!!admin);
    })();
  }, []);

  if (isAdmin === null) return null;
  if (!isAdmin) return <Navigate to={redirectTo} replace />;
  return children;
}
